import accounting from 'accounting';
export var DecimalFormats;
(function (DecimalFormats) {
    DecimalFormats["Dot"] = "dot";
    DecimalFormats["Comma"] = "comma";
})(DecimalFormats || (DecimalFormats = {}));
export var GroupDelimiter;
(function (GroupDelimiter) {
    GroupDelimiter["Dot"] = "dot";
    GroupDelimiter["Comma"] = "comma";
    GroupDelimiter["Space"] = "space";
})(GroupDelimiter || (GroupDelimiter = {}));
const GroupSeparatorNameToSignMap = {
    dot: '.',
    comma: ',',
    space: ' '
};
const DecimalSeparatorNameToSignMap = {
    dot: '.',
    comma: ','
};
const mapNumberOptionsToNumberSettings = ({ digits, decimalFormat = DecimalFormats.Dot, groupDelimiter = GroupDelimiter.Comma } = {
    decimalFormat: DecimalFormats.Dot,
    groupDelimiter: GroupDelimiter.Comma
}) => {
    const settings = {
        decimal: DecimalSeparatorNameToSignMap[decimalFormat],
        thousand: GroupSeparatorNameToSignMap[groupDelimiter]
    };
    if (typeof digits === 'number') {
        settings.precision = digits;
    }
    return settings;
};
const stripTrailingDecimalZeros = (numberString, decimalSeparator, optionDigits) => {
    if (!optionDigits) {
        const [num, fraction] = numberString.split(decimalSeparator);
        if (fraction && Number(fraction) === 0) {
            return num;
        }
    }
    return numberString;
};
const formatToPrint = (num, options = {}) => {
    if (typeof num !== 'number') {
        return '0';
    }
    const formatSettings = mapNumberOptionsToNumberSettings(options);
    if (!Number.isInteger(num) && formatSettings.precision == null) {
        formatSettings.precision = 1;
    }
    return stripTrailingDecimalZeros(accounting.formatNumber(num, Object.assign(Object.assign({}, formatSettings), { thousand: '' })), formatSettings.decimal, options === null || options === void 0 ? void 0 : options.digits);
};
const formatNumber = (num, options = {}) => {
    if (num == null) {
        return '0';
    }
    const formatSettings = mapNumberOptionsToNumberSettings(options);
    if (!Number.isInteger(num) && formatSettings.precision == null) {
        formatSettings.precision = 2;
    }
    return stripTrailingDecimalZeros(accounting.formatNumber(num, formatSettings), formatSettings.decimal, options === null || options === void 0 ? void 0 : options.digits);
};
const formatWithSymbol = (num, options = { digits: 2 }) => {
    if (num == null) {
        return '0';
    }
    const si = [
        { value: 1, symbol: '' },
        { value: 1E3, symbol: 'K' },
        { value: 1E6, symbol: 'M' },
        { value: 1E9, symbol: 'G' },
        { value: 1E12, symbol: 'T' },
        { value: 1E15, symbol: 'P' },
        { value: 1E18, symbol: 'E' }
    ];
    let i;
    for (i = si.length - 1; i > 0; i--) {
        if (num >= si[i].value) {
            break;
        }
    }
    const numberSettings = mapNumberOptionsToNumberSettings(options);
    const decimalSeparatorSign = numberSettings.decimal;
    const rx = new RegExp(`\\${decimalSeparatorSign}0+$|(\\${decimalSeparatorSign}[0-9]*[1-9])0+$`);
    return `${accounting.formatNumber(num / si[i].value, numberSettings).replace(rx, '$1')}${si[i].symbol}`;
};
export { formatToPrint, formatNumber, formatWithSymbol };
//# sourceMappingURL=index.js.map